import React, { createContext, useContext, ReactNode } from 'react';
import { Device, DeviceType } from '@/utils/getDeviceType';

interface PageContextProps {
  deviceType?: DeviceType;
  device?: Device;
}

const PageContext = createContext<PageContextProps | undefined>({
  deviceType: undefined,
  device: { model: null, vendor: null },
});

export const PageContextProvider = ({
  children,
  device,
  deviceType,
}: {
  children: ReactNode;
  device: Device;
  deviceType: DeviceType;
}) => {
  return (
    <PageContext.Provider value={{ device, deviceType }}>
      {children}
    </PageContext.Provider>
  );
};

export const usePageContext = () => {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error('usePageContext must be used within PageContextProvider');
  }
  return context;
};
